export default { sha: 'ae4a218c392cb25d3b1f3a55976fc1d03a73d2d6', buildNumber: 'undefined' }
